import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import NutritionPage from './pages/NutritionPage';
import EntrainementPage from './pages/EntrainementPage';
import HubPage from './pages/HubPage';
import MetricsPage from './pages/MetricsPage';
import ProfilPage from './pages/ProfilPage';
import AdminPage from './pages/AdminPage';
import EditProgramPage from './pages/EditProgramPage';
import DashboardPerfPage from './pages/DashboardPerfPage';
import ChallengePage from './pages/ChallengePage';
import './App.css';

const TOAST_OPTIONS = {
  style: {
    background: '#1B1B1B',
    border: '1px solid #2A2A2E',
    color: '#FFFFFF'
  }
};


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#0F0F0F]">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            
            {/* Main 5 tabs */}
            <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/entrainement" element={<ProtectedRoute><EntrainementPage /></ProtectedRoute>} />
            <Route path="/nutrition" element={<ProtectedRoute><NutritionPage /></ProtectedRoute>} />
            <Route path="/hub" element={<ProtectedRoute><HubPage /></ProtectedRoute>} />
            <Route path="/profil" element={<ProtectedRoute><ProfilPage /></ProtectedRoute>} />
            
            {/* Sub pages */}
            <Route path="/challenge" element={<ProtectedRoute><ChallengePage /></ProtectedRoute>} />
            <Route path="/metriques" element={<ProtectedRoute><MetricsPage /></ProtectedRoute>} />
            <Route path="/performance" element={<ProtectedRoute><DashboardPerfPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
            <Route path="/edit-programs" element={<ProtectedRoute><EditProgramPage /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <Toaster position="bottom-center" toastOptions={TOAST_OPTIONS} />

      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
